export default class DropDownListModel {
    constructor(
        labelText: string,
        identifier: string,
        checked: boolean) {
            this.labelText = labelText
            this.identifier = identifier
            this.checked = checked
        }

    labelText: string
    identifier: string
    checked: boolean

    static createEmpty(): DropDownListModel {
        return new DropDownListModel("", "", false)
    }
}
